import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function saveTaxType(app, dataToSave) {
  const { user={}, data } = dataToSave;
  let taxTypeData = {
    doc_type: DocType.TAX_TYPE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    system_defined: util.toBoolean(data.system_defined)
  };
  return common.saveDoc(app, {
    source: data,
    doc: taxTypeData,
    user,
  });
}

export function fetchTaxTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'tax_type/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function deleteTaxType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.TAX_TYPE
  });
}

export function fetchTaxTypeById(app, params) {
  const { id } = params;
  const docType = DocType.TAX_TYPE;
  return common.getDoc(app, { id, docType });
}
